/**
 * @author: SuperHorse.马超 machao@meitunmama.com
 * Created on 2018/11/8.
 *
 */
export default {
  getAdverts: '/newapi/router/health-heathAd/getAdverForVip', // 大健康广告位
  getScholarshipDetail: '/newapi/router/jxj/getDetail', // 奖学金计划详情页
  updateRemind: '/newapi/router/jxj/updateRemind', // 弹窗状态更新提醒
  getAdvertsGeneral: '/newapi/router/health-heathAd/getAdverts', // 通用广告位资源接口
  getScholarshipsList: '/newapi/router/jxj/listJxjActivity', // 奖学金计划列表页接口
  getcertificate: '/newapi/wallet/account/authentication/getcertificate', // 查询实名认证状态
  getVerifySend: '/newapi/wallet/account/verify/send', // 发送短信验证码
  getVerifyValid: '/newapi/wallet/account/verify/valid', // 校验短信验证码
  getVerified: '/newapi/wallet/account/authentication/identityauthentication', // 钱包实名认证
  sendPlayDuration: '/newapi/bigHealth/course/play', // 播放进度
  getMyListJxjActivity: '/newapi/router/jxj/myListJxjActivity', // 我的奖学金计划接口
  getUserPhone: '/newapi/router/user/getUserInfo', // 获取用户信息手机号
  getIconList: '/newapi/router/health-jxjPunch/getPunchCards', // 打卡日历
  getJxjCollectLikes: 'newapi/router/health-jxjLikes/getJxjCollectLikes', // 集赞-集赞任务信息页
  getJxjStartLikes: 'newapi/router/health-jxjLikes/startJxjCollectLikes', // 集赞-发起集赞
  getJxjDoLikes: 'newapi/router/health-jxjLikes/doJxjCollectLikes', // 集赞-点赞
  getPunchCardShare: 'newapi/router/health-jxjPunch/punchCardShare', // 打卡信息查询 获取分享图片
  getPunchCard: 'newapi/router/health-jxjPunch/punchCard', // 打卡完成接口
  secretToken: '/newapi/router/health-jxjPunch/jxjUserToken'  // token 加密接口
};



// WEBPACK FOOTER //
// ./src/comm/api/scholarships/index.js